<loader *ngIf="saving"></loader>

<cat-cards
  [selectMode]="true"
  (onCardsSelected)="onCardsSelected($event)"
></cat-cards>
